import { useContext, useEffect, useState } from "react";
import { Box, Container, Typography } from "@mui/material";
import UserContext from "../../../navigation/context/userContext";
import { GetEventByID } from "../../../controllers/customer/EventosController";
import { useHistory, useParams } from "react-router-dom/cjs/react-router-dom";
import Review from "../../../components/review";
import QUDProgress from "../../../components/progress";
import { imagesURL } from "../../../apiRoutes/apiBase";
import { GetData } from "../../../controllers/MerchantsController";

export default function MerchantReview(){
    const { userData } = useContext(UserContext);
    const [merchant,setMerchant] = useState([]);
    const [comment,setComment] = useState('');

    const [openReview,setOpenReview] = useState(false);

    const [isLoading,setIsLoading] = useState(false);
    const [open,setOpen] = useState(false);
    const [success,setSuccess] = useState(false);
    const [title,setTitle] = useState('');
    const [message,setMessage] = useState();
    const [actionText,setActionText] = useState('');

    const [showModal,setShowModal] = useState(false);

    const { uuid } = useParams();
    
    const history = useHistory();

    const redireccionar = (route) => {
        history.push(route)
    }
    

    useEffect(()=>{
        localStorage.setItem('openModalReviewMerchant',true)
        handleGetData();
        handleReviewLocalStorage();
        /*if(userData.user !== undefined)
        {
            setName(userData.entity.name);
            setLastName(userData.entity.last_name);
            setDocumentType(userData.entity.document_type);
            setDocument(userData.entity.document_number);
            setPrefix(userData.user.prefijo);
            setPhoneNumber(userData.entity.phone);
            setEmail(userData.user.email);
        }*/
        window.scrollTo(0,0);
    },[]);

    const handleGetData = async () => {
        setIsLoading(true);
        let response = await GetData(uuid);
        console.log('REVIEW ===> ',response)
        if(response.success === true)
        {
            setMerchant(response.data);
            //setTickets(response.data.tickets);
            //handleSettingTickets(response.data.tickets);
        }
        setIsLoading(false);
    }

    const handleReviewLocalStorage = () => {
        if(localStorage.getItem('openModalReviewMerchant') === 'true')
            setOpenReview(true)
    }

    const handleCloseReview = () => {
        localStorage.removeItem('openModalReviewMerchant')
        setOpenReview(false);
        redireccionar(`/places/${uuid}`)
    }

    return(
        <Container maxWidth='lg'>
            <QUDProgress open={isLoading}/>
            <Box sx={{minHeight:'95vh'}}></Box>
            {
                merchant.length !== 0 &&
                <Review
                    type='merchant'
                    toUUID={merchant.uuid}
                    open={openReview}
                    image={merchant.profile_image}
                    name={merchant.merchant}
                    handleClose={()=>handleCloseReview()}
                />
            }
        </Container>
    )
}